<!-- Shipment Details Dialog -->
<p-dialog [(visible)]="visible" [modal]="true" [style]="{ width: '50vw', maxWidth: '1000px' }"
    position="left" styleClass="tender-list-dialog">
    <ng-template pTemplate="header">
        <p-tabView [(activeIndex)]="activeTabIndex" styleClass="dialog-header-tabs">
            <p-tabPanel header="New Tenders ({{newTenders.length}})"></p-tabPanel>
            <p-tabPanel header="Cancelled Tenders ({{cancelledTenders.length}})"></p-tabPanel>
        </p-tabView>
        <p-button class="pr-2" *ngIf="activeTabIndex === 0" label="Add All" icon="pi pi-plus" outlined="true" raised="true" (click)="addAllTenders()"></p-button>
        <p-button class="pr-2" *ngIf="activeTabIndex === 1" label="Update All" icon="pi pi-plus" outlined="true" raised="true" (click)="updateAllTenders()"></p-button>
    </ng-template>
    <div class="tender-content">
        <!-- Skeleton Loading State -->
        <div *ngIf="loading" class="tender-item">
            <p-card>
                <div class="flex align-items-center gap-2">
                    <div class="info-section" style="width: 120px">
                        <p-skeleton width="80px" height="18px" styleClass="mb-1" [style]="{'margin-left': '0'}"></p-skeleton>
                        <p-skeleton width="100px" height="22px" [style]="{'margin-left': '0'}"></p-skeleton>
                    </div>
                    <div class="info-section" style="width: 250px; text-align: center">
                        <p-skeleton width="90px" height="18px" styleClass="mb-1" [style]="{'margin': '0 auto'}"></p-skeleton>
                        <p-skeleton width="180px" height="22px" [style]="{'margin': '0 auto'}"></p-skeleton>
                    </div>
                    <div class="info-section flex-1" style="width: 200px; text-align: center">
                        <p-skeleton width="100px" height="18px" styleClass="mb-1" [style]="{'margin': '0 auto'}"></p-skeleton>
                        <p-skeleton width="160px" height="22px" [style]="{'margin': '0 auto'}"></p-skeleton>
                    </div>
                    <div class="action-section">
                        <p-skeleton shape="circle" size="2rem"></p-skeleton>
                    </div>
                </div>
            </p-card>
        </div>

        <!-- Tender Content -->
        <div *ngIf="!loading" class="tender-list">
            <ng-container *ngIf="activeTabIndex === 0">
                <div *ngFor="let tender of newTenders" class="tender-item cursor-pointer mb-2"
                    [class.selected]="selectedTender?.messageId === tender.messageId">
                    <p-card (click)="loadTenderDisplay(tender)">
                        <div class="flex align-items-center gap-2">
                            <div class="info-section" style="width: 120px">
                                <div class="label">Order Number</div>
                                <div class="value">{{ tender.extracted_info.order_number }}</div>
                            </div>
                            <div class="info-section" style="width: 250px">
                                <div class="label">Start Location</div>
                                <div class="value">{{ tender.extracted_info.start_location }}</div>
                            </div>
                            <div class="info-section flex-1" style="width: 200px">
                                <div class="label">Delivery</div>
                                <div class="value">{{ getDeliveryLocation(tender.extracted_info.final_del_location) }}</div>
                            </div>
                            <div class="action-section">
                                <i class="pi pi-arrow-right"></i>
                            </div>
                        </div>
                    </p-card>
                </div>
            </ng-container>
            <ng-container *ngIf="activeTabIndex === 1">
                <div *ngFor="let tender of cancelledTenders" class="tender-item cursor-pointer mb-2"
                    [class.cancelled]="true" [class.selected]="selectedTender?.messageId === tender.messageId">
                    <p-card (click)="loadTenderDisplay(tender)">
                        <div class="flex align-items-center gap-2">
                            <div class="info-section" style="width: 120px">
                                <div class="label">Order Number</div>
                                <div class="value">{{ tender.extracted_info.order_number }}</div>
                            </div>
                            <div class="info-section" style="width: 250px">
                                <div class="label">Start Location</div>
                                <div class="value">{{ tender.extracted_info.start_location }}</div>
                            </div>
                            <div class="info-section flex-1" style="width: 200px">
                                <div class="label">Delivery</div>
                                <div class="value">{{ getDeliveryLocation(tender.extracted_info.final_del_location) }}</div>
                            </div>
                            <div class="action-section">
                                <i class="pi pi-arrow-right"></i>
                            </div>
                        </div>
                    </p-card>
                </div>
            </ng-container>
        </div>
    </div>
</p-dialog>




<p-dialog [(visible)]="tenderVisible" [style]="{ width: '47vw', maxWidth: '800px', height: '100vh' }" position="right" [modal]="false"
    [blockScroll]="true" [ngClass]="{'tender-dialog': true, 'animate-pull-out': showPullOutAnimation}" (onHide)="handleTenderDialogHide()" [closable]="true">
    <ng-template pTemplate="header">
        <span class="text-lg font-bold" [class.cancelled]="selectedTender?.is_cancelled">{{emailSubject}}</span>
    </ng-template>
    <div class="email-content">
        <iframe *ngIf="!loading && emailContent" [srcdoc]="emailContent" frameborder="0"></iframe>
        <div *ngIf="!loading && !emailContent" class="error-message">
            <p>No content available</p>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <button pButton label="Close" icon="pi pi-times" class="p-button-text" (click)="handleTenderDialogHide()"></button>
        <button *ngIf="!selectedTender?.is_cancelled" pButton label="Add to Orders" icon="pi pi-plus" class="p-button-info" outlined="true"
            raised="true" (click)="openNewOrder(selectedTender!)"></button>
        <button *ngIf="selectedTender?.is_cancelled" pButton label="Update Order Status" class="p-button-danger" outlined="true"
            raised="true" (click)="updateOrderStatus(selectedTender!)"></button>
    </ng-template>
</p-dialog>

<app-new-order-dialog 
    [customers]="customers" 
    [receiverOptions]="receiverOptions" 
    [supplierOptions]="supplierOptions"
    [trailers]="trailers" 
    [loadTypesArray]="loadTypesArray" 
    [loadType]="loadType"
    [isForTender]="true"
    [tenderPosition]="'left'"
    [tenderCounter]="tenderCounter"
    [tenderTotal]="tenderTotal">
</app-new-order-dialog>

<p-confirmDialog></p-confirmDialog>